<template>
  <div class='row'>
    <div class='col-xs-12'>
      <multi-select 
        v-model="selectedTags"
        track-by="name"
        label="name"
        open-direction="bottom"
        :placeholder="lang.get('event_strings.photo_stream.tag_attendees')"
        :multiple="true"
        :options="this.results"
        @search-change="(res) => debounceQuerySearch(res)"
        @select="optionSelected"
        @remove="optionRemoved"
        :type="this.type"
      >
        <template v-slot:noOptions v-if="this.isBaseStyle">
          {{ lang.get('event_strings.photo_stream.type_name_before_search') }}
        </template>
        <template v-slot:noOptions v-else>
          {{ lang.get('event_strings.photo_stream.type_name_attendee') }}
        </template>
        <template v-slot:noResult>
          {{ searching || fetching ? lang.get('event_strings.photo_stream.searching') : lang.get('event_strings.photo_stream.no_attendees_found') }}
        </template>        
      </multi-select>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

const debounce = (func, delay) => { 
    let debounceTimer 
    return function() { 
      const context = this
      const args = arguments 
      clearTimeout(debounceTimer) 
      debounceTimer = setTimeout(() => func.apply(context, args), delay) 
    } 
}  

  export default {
    inject: ['isBaseStyle'],
    props: ['apiAuthToken', 'eventId', 'baseUrl', 'tags', 'type'],

    data () {
      return {
        selectedTags: [],
        debounce: null,
        fetching: false,
        searching: false,
        results: [],
        prevRequest: ''
      }
    },

    computed: {
      noOptionText () {
        return this.searchInput && this.searchInput.length ? lang.get('event_strings.photo_stream.no_attendees_found') : lang.get('event_strings.photo_stream.type_name_attendee') 
      },
      formatAttendeeTags () {
        var mapped = this.tags.map(function(attendeeTag) {
            attendeeTag.name = `${attendeeTag.first_name} ${attendeeTag.last_name}`
            return attendeeTag
        })
        return mapped
      }
    },

    created: function() {
      this.setSelectedTags()
    },

    methods: {

      setSelectedTags () {
        this.selectedTags = this.formatAttendeeTags
      },
      
      querySearch (res) {
        if (res.trim() == '') {
          this.results = [];
          return;
        } 
          
        this.fetching = true

        var url = `/events/${this.eventId}/eventAttendeeSearch`
        if ((typeof this.baseUrl === 'string' || this.baseUrl instanceof String) && this.baseUrl != '') {
          url = this.baseUrl+`/events/${this.eventId}/eventAttendeeSearch`
        }

        axios.get(url, {
          params: {
            query: res, 
            api_auth_token: this.apiAuthToken
          }
        }).then((response) => {
          if (response.data && response.data.data) {
            this.results = response.data.data.map((attendee) => {
              attendee.label = `${attendee.first_name} ${attendee.last_name}`
              attendee.name = attendee.label
              return attendee
            })
          }
        }).catch((e) => {
          console.log(e)
        }).finally(() => {
          this.fetching = false
          this.searching = false
        })
      },

      debounceQuerySearch (res) {
        this.searching = true
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          this.querySearch(res)
        }, 300)
      },

      optionSelected (option, id) {
        this.$emit('select', option)
      },
      
      optionRemoved (option, id) {
        this.$emit('remove', option)  
      },

    },

  }
  
</script>